import { CardContent } from "@material-ui/core";
import Card from "@material-ui/core/Card";
import InputAdornment from "@material-ui/core/InputAdornment";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import CardTitle from "@saleor/components/CardTitle";
import { FormChange } from "@saleor/hooks/useForm";
import React from "react";

import { ProductCreateData } from "../ProductCreatePage";
import { ProductUpdateData } from "../ProductUpdatePage/form";
import { ProductVariantCreateData } from "../ProductVariantCreatePage/form";
import { ProductVariantPageFormData } from "../ProductVariantPage";

const useStyles = makeStyles(
  theme => ({
    currencySymbol: {
      fontSize: "0.875rem"
    },
    inputContainer: {
      display: "grid",
      gridTemplateColumns: "1fr 2rem 1fr"
    },
    pullDown: {
      marginTop: theme.spacing(2)
    },
    root: {
      display: "grid",
      gridColumnGap: theme.spacing(2),
      gridTemplateColumns: "1fr 1fr"
    },
    separator: {
      marginTop: theme.spacing(3),
      textAlign: "center",
      width: "100%"
    },
    widgetContainer: {
      marginTop: theme.spacing(2)
    }
  }),
  { name: "PriceField" }
);

interface ProductDimensionFormProps {
  data:
    | ProductVariantPageFormData
    | ProductUpdateData
    | ProductVariantCreateData
    | ProductCreateData;
  validate?: {
    height: null;
    length: null;
    weight: null;
    width: null;
  };
  title: string;
  isStoreAdmin?: boolean;
  onFormDataChange: FormChange;
}

const ProductDimension: React.FC<ProductDimensionFormProps> = props => {
  const { data, title, isStoreAdmin, onFormDataChange, validate } = props;

  const classes = useStyles(props);
  return (
    <Card>
      <CardTitle title={title} />
      <CardContent>
        <div className={classes.root}>
          <div className={classes.pullDown}>
            <TextField
              error={!!validate?.weight}
              helperText={validate?.weight}
              id="weightTxt"
              label="Weight"
              fullWidth
              value={data.weight || ""}
              InputProps={{
                endAdornment: (
                  <InputAdornment
                    position="end"
                    className={classes.currencySymbol}
                  >
                    KG
                  </InputAdornment>
                ),
                readOnly: isStoreAdmin,
                type: "number"
              }}
              name="weight"
              // disabled={disabled}
              onChange={onFormDataChange}
            />
          </div>
          <div className={classes.pullDown}>
            <TextField
              error={!!validate?.width}
              helperText={validate?.width}
              id="widthTxt"
              label="Width"
              fullWidth
              value={data.width || ""}
              InputProps={{
                endAdornment: (
                  <InputAdornment
                    position="end"
                    className={classes.currencySymbol}
                  >
                    CM
                  </InputAdornment>
                ),
                readOnly: isStoreAdmin,
                type: "number"
              }}
              name="width"
              onChange={onFormDataChange}
            />
          </div>
          <div className={classes.pullDown}>
            <TextField
              error={!!validate?.height}
              helperText={validate?.height}
              id="heightTxt"
              label="Height"
              fullWidth
              value={data.height || ""}
              InputProps={{
                endAdornment: (
                  <InputAdornment
                    position="end"
                    className={classes.currencySymbol}
                  >
                    CM
                  </InputAdornment>
                ),
                readOnly: isStoreAdmin,
                type: "number"
              }}
              name="height"
              onChange={onFormDataChange}
            />
          </div>
          <div className={classes.pullDown}>
            <TextField
              error={!!validate?.length}
              helperText={validate?.length}
              id="lengthTxt"
              label="Length"
              fullWidth
              value={data.length || ""}
              InputProps={{
                endAdornment: (
                  <InputAdornment
                    position="end"
                    className={classes.currencySymbol}
                  >
                    CM
                  </InputAdornment>
                ),
                readOnly: isStoreAdmin,
                type: "number"
              }}
              name="length"
              onChange={onFormDataChange}
            />
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
ProductDimension.displayName = "Product Dimension";
export default ProductDimension;
